import { MultiSelectOptions } from '@shared/ui'
import { AnnuityState } from '@sr/data-access'

export const FORM_FILTER_NAME = Object.freeze({
  socialReferent: 'socialReferent',
  promPlanAppointment: 'promPlanAppointment',
  annuityStates: 'annuityStates',
})

export const scheduledOptions = (
  t: (trans: string) => string,
): MultiSelectOptions[] => [
  { label: t('common:scheduled'), value: '1' },
  { label: t('common:noScheduled'), value: '0' },
]

export const annuityStateOptions = (
  t: (trans: string) => string,
) => [
  {
    label: t('common:annuityState.pending'),
    value: AnnuityState.pending,
    defaultChecked: true,
  },
  {
    label: t('common:annuityState.accepted'),
    value: AnnuityState.accepted,
    defaultChecked: true,
  },
  {
    label: t('common:annuityState.detached'),
    value: AnnuityState.detached,
    defaultChecked: false,
  },
  {
    label: t('common:annuityState.cancelled'),
    value: AnnuityState.cancelled,
    defaultChecked: false,
  },
  {
    label: t('common:annuityState.finished'),
    value: AnnuityState.finished,
    defaultChecked: false,
  },
]
